import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { MODAL_PRO_UPGRADE, POPOVER_NOTIFICATION_SETTINGS } from '../../constants'
import { setFilter } from '../../actions/notifications'
import { openPopover } from '../../actions/popover'
import PanelLayout from './panel_layout'
import SettingSwitch from '../setting_switch'
import Icon from '../icon'
import Dummy from '../dummy'
import Button from '../button'
import Text from '../text'
import { isPro } from '../../initial_state'
import { openModal } from '../../actions/modal'

class NotificationFilterPanel extends ImmutablePureComponent {

  handleOnClickSettings = () => {
    if (!isPro) {
      const subtitle = 'noti-filters'
      this.props.onOpenProModal(subtitle)
      return true;
    }

    this.props.onOpenPopover(this.node)
  }

  setRef = (n) => {
    this.node = n
  }

  render() {
    const { onChange, settings, noPanel } = this.props

    const classes = noPanel ? [_s.d, _s.px5, _s.w100PC].join(' ') : undefined
    const Wrapper = noPanel ? Dummy : Fragment

    return (
      <PanelLayout
        noPanel={noPanel}
        noPadding={noPanel}
        title='Notification Settings'
        headerButtonTitle={noPanel ? undefined : <Icon id='cog'/>}
        headerButtonRef={noPanel ? undefined :  this.setRef}
        headerButtonAction={noPanel ? undefined : this.handleOnClickSettings}
      >
        <Wrapper className={classes}>
          <SettingSwitch
            prefix='notification'
            settings={settings}
            settingPath={'onlyVerified'}
            onChange={onChange}
            label='Only verified users'
          />

          <SettingSwitch
            prefix='notification'
            settings={settings}
            settingPath={'onlyFollowing'}
            onChange={onChange}
            label='Only accounts you follow'
          />
        </Wrapper>
        {
          noPanel &&
          <div className={[_s.d, _s.borderTop1PX, _s.borderColorSecondary, _s.mt10, _s.pt15, _s.px5, _s.w100PC].join(' ')}>
            <Button
              radiusSmall
              backgroundColor='tertiary'
              color='secondary'
              buttonRef={this.setRef}
              onClick={this.handleOnClickSettings}
              className={[_s.aiCenter, _s.jcCenter].join(' ')}
            >
              <Text color='inherit' weight='medium'>Clear notifications</Text>
            </Button>
          </div>
        }
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  settings: state.getIn(['notifications', 'filter']),
})

const mapDispatchToProps = (dispatch) => ({
  onChange(path, value) {
    if (!isPro) {
      dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle: 'noti-filters' }))
    } else {
      dispatch(setFilter(path, value))
    }
  },
  onOpenPopover(targetRef) {
    dispatch(openPopover(POPOVER_NOTIFICATION_SETTINGS, {
      targetRef,
    }))
  },
  onOpenProModal(subtitle) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  },
})

NotificationFilterPanel.propTypes = {
  onChange: PropTypes.func.isRequired,
  settings: ImmutablePropTypes.map.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationFilterPanel)